import { CoinInfo, CoinDetailJson } from './common';
import { StakeType } from './stake';
import { SupportWallets } from './wallet';

export enum NeedSlippageType {
  NoNeed = 0,
  Need = 1,
}

export enum PoolButtonType {
  Stake = 'stake',
  Claim = 'claim',
  Unstake = 'redeem',
  DelayUnstake = 'delayRedeem',
}

export enum PoolButtonStatus {
  Disabled = 0,
  Useful = 1,
}

export interface RiskNotice {
  /** 领取风险提示 **/
  claimRiskText?: string;
  /** 领取风险跳转URL	**/
  claimRiskUrl?: string;
  /** 质押风险提示 **/
  stakeRiskText?: string;
  /** 质押风险跳转URL **/
  stakeRiskUrl?: string;
  /** 解押风险提示 **/
  unstakeRiskText?: string;
  /** 解押风险跳转URL **/
  unstakeRiskUrl?: string;
}
export interface EmergencyMode {
  whiteList: string[];
  enable: boolean;
  buttons: string[];
}

export enum PoolLabelAprFlag {
  APR = 1,
  APY = 0,
}

export type PoolExtendDTO = {
  poolAssetList: {
    name: string;
    type: number;
    subtitle: string[];
    picUrl: string;
  }[];
  poolOperationList: {
    name: string;
    type: number;
    subtitle: string[];
    picUrl: string;
  }[];
  poolButtonList?: {
    name: PoolButtonType;
    status: PoolButtonStatus;
    title: string;
  }[];
  delayTime: number;
  stakeRange: {
    min: string;
    max: string;
  };
  unstakeRange: {
    min: string;
    max: string;
  };
  /** 风险文案 **/
  riskNotice?: RiskNotice;
  emergencyMode?: EmergencyMode;
  poolLabelDTO: {
    /* 1池子展示apr 0 展示apy*/
    aprFlag: number;
    /** 是否是稳定币 */
    stable?: number;
    /** 是否是奖励金 */
    reward?: number;
    /** 是否是积分 */
    points?: number;
    /** 再质押 */
    restake?: number;
    /** 是否是单币 */
    single?: number;
    /** 是否是多币 */
    multiple?: number;
  };
  tonExtra: {
    stakeExtraAmount: string;
    gasAttached: Array<string>;
  };
};

export type PoolInfo = {
  id: number;
  baseCoin: CoinInfo[];
  baseStakeCoins: CoinInfo[];
  chainCode: string;
  chainId: number;
  coinContractAddress: string;
  contractAddress: string;
  gaugeAddress: string;
  claimAddrs: {
    contractAddress: string;
  }[];
  poolCode: string;
  poolType: string;
  poolName: string;
  apy: string;
  icon: {
    day: string;
    night: string;
  };
  multipleCoins: CoinInfo[];
  singleCoins: CoinInfo[];
  whiteList: CoinInfo[];
  tvl: string;
  /** pool的活动标签 */
  activityFlags: string[] | null;
  /** 资金使用率 */
  utilization: string;
  /**  */
  stakeType: StakeType;
  needSlippage: NeedSlippageType;
  supportWallets: (SupportWallets.bybitWallet | SupportWallets.thirdWallet)[];
  noticeConfigDTO: {
    title: string;
    content: string;
  };
  faqList: {
    subject: string;
    content: TrustedHTML;
    id: number;
    sceneCode: string;
  }[];
  poolExtendDTO: PoolExtendDTO;
  projectName: string;
  isHaveSwap: boolean;
  poolIcons?: CoinDetailJson[];
  tvlLimitDTO?: {
    supplyMax: string;
    supplyNow: string;
    coinDetail: CoinDetailJson;
  };
  extraReward: {
    rewardApy: number;
    rewardSymbol: string;
    activityStartTimestamp: number;
  };
  lpCoin: CoinDetailJson;
  ratio: string;
  lpPrice?: string;
  offline: boolean;
};

export type GetPoolInfoRes = PoolInfo;

export type GetPoolListRes = PoolInfo[];
